function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  d: "M5.5 1.833l.082.008a.458.458 0 0 1 .376.45v6.876a.458.458 0 1 1-.916 0V2.292l.007-.083a.458.458 0 0 1 .451-.376zM8.708 5.5c.253 0 .459.205.459.458v3.209a.458.458 0 1 1-.917 0V5.958l.007-.082a.458.458 0 0 1 .451-.376zM2.292 3.667l.082.007a.458.458 0 0 1 .376.451v5.042a.458.458 0 1 1-.917 0V4.125l.008-.082a.458.458 0 0 1 .45-.376z"
});

var SvgBarChart = function SvgBarChart(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 11 11",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgBarChart, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bar-chart.d86f07c6.svg";
export { ForwardRef as ReactComponent };